import { ExpandMore } from '@mui/icons-material'
import {
  lighten,
  ListItemButton,
  ListItemText,
  Paper,
  Popover,
  Stack,
  useTheme,
} from '@mui/material'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'

import { TAppNavItem } from '~/layouts/app/utils'
import rem from '~/utils/ui'

type TProps = {
  navItem: TAppNavItem
  colorTrigger: boolean
}
function NavItemWithDropdown({ navItem, colorTrigger }: TProps) {
  const theme = useTheme()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const open = Boolean(anchorEl)

  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    if (!open) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  return (
    <Stack
      sx={{
        position: 'relative',
      }}
      onMouseEnter={handlePopoverOpen}
      onMouseLeave={handlePopoverClose}
    >
      <ListItemButton
        key={navItem.name}
        sx={{
          '& svg': {
            ml: rem(10),
            color: colorTrigger
              ? theme.palette.secondary1
              : theme.palette.common.white,
            transition: 'transform 0.3s ease',
            transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
          },
        }}
      >
        <ListItemText
          primaryTypographyProps={{
            sx: {
              textTransform: 'uppercase',
              fontWeight: 600,
              fontSize: '0.8rem',
              color: colorTrigger
                ? theme.palette.secondary1
                : theme.palette.common.white,
            },
          }}
          primary={navItem.name}
        />
        <ExpandMore />
      </ListItemButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        disableRestoreFocus
        slotProps={{
          paper: {
            onMouseLeave: handlePopoverClose,
          },
        }}
      >
        {navItem.children && (
          <Paper>
            {navItem.children.map(({ path, name }) => (
              <ListItemButton
                key={name}
                component={NavLink}
                to={path ?? ''}
                sx={{
                  paddingBlock: rem(10),
                  paddingInline: rem(30),
                  color: colorTrigger
                    ? theme.palette.secondary1
                    : theme.palette.common.white,
                  backgroundColor: colorTrigger
                    ? theme.palette.common.white
                    : lighten(theme.palette.menuBackground, 0.1),
                  '& span': {
                    fontSize: rem(13),
                    fontWeight: 600,
                  },
                  '&:hover': {
                    backgroundColor: colorTrigger
                      ? lighten(theme.palette.tertiary5, 0.6)
                      : lighten(theme.palette.menuBackground, 0.3),
                  },
                }}
              >
                <ListItemText primary={name} />
              </ListItemButton>
            ))}
          </Paper>
        )}
      </Popover>
    </Stack>
  )
}
export default NavItemWithDropdown
